import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { engagementDeliveryInfoMapper } from '@epicuro-next/data/engagement/engagement-api-utils';
import {
  CommercialListGetDeliveryInfoRequestDto,
  CommercialListValidateRequestDto,
  CommercialListValidationResponseDto,
  ENGAGEMENT_API_TOKEN,
  ListDeliveryInfoResponseDto,
  ProductListBaseAddRequestDto,
  ProductListUpdateRequestDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { map } from 'rxjs/operators';

import { ProductListApiService } from '../product-list-api/product-list-api.service';

@Injectable()
export class CommercialListApiService {
  constructor(
    private http: HttpClient,
    private productListApi: ProductListApiService,
    @Inject(ENGAGEMENT_API_TOKEN) private readonly baseUrl: string,
  ) {}

  public create(payload: ProductListBaseAddRequestDto) {
    return this.productListApi.create(payload);
  }

  public update(
    payload: ProductListUpdateRequestDto & {
      allowedToChangeDeliveryDate?: boolean;
    },
  ) {
    return this.productListApi.update(payload);
  }

  public uploadCommercialListFile({
    brandId,
    file,
    orderType,
  }: CommercialListValidateRequestDto) {
    const formData = new FormData();
    formData.set('', file);

    const searchParams = new URLSearchParams();

    if (orderType) {
      searchParams.set('orderType', orderType);
    }

    return this.http.post<CommercialListValidationResponseDto>(
      `${this.baseUrl}/deliveryinfo/${brandId}/validate/file${
        '?' + searchParams.toString()
      }`,
      formData,
    );
  }

  public checkDeliveryInfo({
    productListId,
    deliveryDate,
  }: CommercialListGetDeliveryInfoRequestDto) {
    let url = `${this.baseUrl}/productlist/${productListId}/deliveryinfo`;

    if (deliveryDate) url += `?deliveryDate=${deliveryDate}`;

    return this.http
      .get<ListDeliveryInfoResponseDto>(url)
      .pipe(map(engagementDeliveryInfoMapper));
  }
}
